import type { FaireProductEntity } from "../../entity_types/product";

export const p_mkfft2fxdy: FaireProductEntity = {
  token: "p_mkfft2fxdy",
  type: "product",
  name: "Mardi Gras Gemstone Headband - Large - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/b2c83dba953d37ebec75d072b80a0b61d53dbea9dcb8a3ae3b671ad08d0667fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b363c5386db41d4ff85b89fe8a382957dcfe64abd5ef31c0ac82f3ebd4997a65.jpeg",
    "https://cdn.faire.com/fastly/f81012fb3e3f68b360913b5c10aeeda5780aa9ae1a9a80df31a9dcd6d090e057.jpeg",
    "https://cdn.faire.com/fastly/838069a46efbd4c59c40f091531e2ccef58a82c7e623046c142e0076fd8f60c7.jpeg",
    "https://cdn.faire.com/fastly/0860bf44d4b8fed5a36d866186bfdba05f1ae2b7c6c6f9fcf31d1cdf63882fa7.jpeg",
  ],
  priceDollars: 15,
  description:
    "The Mardi Gras Gemstone Headband is the perfect hair accessory for any Mardi Gras celebration or everyday wear.\n\nFeatures:\n * Vibrant purple fabric with green and gold embellishments \n * Satin lined headband \n * Ages 7+ (including adults)\n\nPair this headband with a matching girl's headband and shirt for the perfect mommy & me moment!",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:29.159Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
